<template>
  <el-container :class="['padding-0', { 'full-screen': isFullScreen }]">
    <el-main style="padding-bottom: 0;">
      <el-container class="height-100">
        <el-main class="main-container">
          <div class="main-container-scroll">
            <div class="approval-detail-header">
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="6">
                  <el-button type="text" icon="el-icon-arrow-left" @click="routerChange">{{ $t('返回审批列表') }}</el-button>
                </el-col>
                <el-col :span="6" v-if="queryParams.bizId" style="text-align:right">
                  <span class="text-gray-14">{{ $t('单号') }}：</span>
                  <span class="text-black-15">{{ queryParams.bizId }}</span>
                  <i class="el-icon-document-copy" @click="copyBiz"></i>
                </el-col>
              </el-row>
            </div>
            <el-divider style="margin: 0 0 15px 0"></el-divider>
            <div class="common-info">
              <div class="info-title">
                <div class="title-left">
                  <h3>{{ $i18n.locale === 'zh-CN' ? queryParams.title : (queryParams.titleEn || queryParams.title) }}</h3>
                  <span :class="stateClass">{{ formatState(queryParams.state) }}</span>
                </div>
                <!-- <div>
                  PKI:
                  <el-switch v-model="pkiValue" active-color="#13ce66" inactive-color="#ccc">
                  </el-switch>
                </div> -->
                <div class="title-right" v-if="isShowOperateBtn">
                  <el-button type="success" size="mini" @click="passApproval(1)">{{ $t('通过') }}</el-button>
                  <el-button type="danger" size="mini" @click="passApproval(2)">{{ $t('拒绝') }}</el-button>
                  <!--                <el-button type="text" @click="handlePrint">打印</el-button>-->
                  <!--                <el-button icon="el-icon-full-screen" size="mini" @click="isFullScreen = !isFullScreen">全屏</el-button>-->
                </div>
              </div>
              <div class="approval-info">
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <span class="type-title text-gray-14">{{ $t('审批类型：') }}</span>
                    <span class="type-content text-black-15">{{ $t(Config.APPROVAL_MODEL[queryParams.flowMode])
                    }}</span>
                  </el-col>
                </el-row>
              </div>
              <div class="apply-info">
                <div class="user-info">
                  <img class="user-avatar" src="@/assets/avatar.png" alt="">
                  <span class="user-name">{{ queryParams.applicantName }}</span>
                  <span class="user-group text-gray-14">{{ applicantDesc }}</span>
                </div>
                <div class="apply-time text-gray-14">{{ queryParams.createTime | formatDate }}</div>
              </div>
            </div>
            <el-divider class="margin-0"></el-divider>
            <div class="special-info">
              <div class="special-item" v-for="(item, i) in forms" :key="i">
                <div class="special-title" v-if="item.data">
                  <div class="title-icon"></div>
                  <div class="title-text text-black-15 blood">{{ item.title }}</div>
                </div>
                <div class="special-content">
                  <!--                键值对类型-->
                  <div class="type-key-value" v-if="item.type === 'kv'">
                    <el-row v-for="(subArray, subArrayIndex) in convert2dArray(item.data)" :key="subArrayIndex">
                      <el-col :span="12" v-for="subItem in subArray" :key="subItem.k">
                        <el-row>
                          <el-col :span="6" class="text-gray-14">{{ subItem.k }}</el-col>
                          <el-col :span="18" class="text-black-15 long-word">{{ subItem.v }}</el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                  <!--                表格类型-->
                  <div class="type-list" v-if="item.type === 'list'">
                    <el-table border fit show-header :data="item.data" header-row-class-name="header-row-class"
                      style="width: 100%">
                      <el-table-column :prop="headerItem.prop" :label="headerItem.label" v-for="headerItem in item.heads"
                        :key="headerItem.prop">
                        <template slot-scope="scope">
                          <p v-for="(v, i) in (String(scope.row[headerItem.prop]) || '').split('\n')" :key="i">{{ v }}
                          </p>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!--                附件类型-->
                  <div class="type-attachment" v-if="item.type === 'file'">
                    <el-row :gutter="4" v-for="(attachmentItem, attachmentIndex) in item.data" :key="attachmentIndex"
                      class="attachment-item">
                      <el-col :span="3" class="text-gray-14">{{ attachmentItem.category }}</el-col>
                      <el-col :span="21">
                        <div class="attachment-box">
                          <div class="attachment-log">
                            <img :src="getFileLogo(attachmentItem.type)" alt="">
                          </div>
                          <div class="attachment-description">
                            <div class="attachment-name text-black-15">{{ attachmentItem.name }}</div>
                            <div class="attachment-size text-gray-14">{{ attachmentItem.size }}</div>
                          </div>
                          <div class="attachment-operation">
                            <a :href="attachmentItem.src" target="_blank">
                              <i class="el-icon-download"></i>
                            </a>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <!--                附言类型-->
                  <div class="type-remark text-black-15" v-if="item.type === 'remark'">
                    {{ item.data }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="collapse-bar">
            <div class="collapse-line"></div>
            <div class="collapse-button" @click="toggleSidebar">
              <i :class="isCollapsed ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
            </div>
          </div>
        </el-main>
        <el-aside :class="['sidebar', { collapsed: isCollapsed }]">
          <div>
            <div class="approval-step">
              <div class="approval-progress">
                <div class="progress-dot"></div>
                <div class="progress-line"></div>
              </div>
              <div class="approval-box">
                <div class="approval-item">
                  <div class="approval-role">
                    <span class="text-black-15">{{ $t('发起人') }}</span>
                    <span class="text-gray-15">{{ $t('发起审批') }}</span>
                  </div>
                  <div class="approval-users">
                    <div class="user-item">
                      <div class="user-info">
                        <img class="user-avatar" src="@/assets/avatar-blue.png" alt="">
                        <el-tooltip popper-class="tooltip-width-box" effect="dark" :content="queryParams.applicantName"
                          placement="left">
                          <span class="text-gray-14 card-name">{{ queryParams.applicantName }}</span>
                        </el-tooltip>
                      </div>
                      <div class="operate-time text-gray-14">{{ queryParams.createTime | formatDateWithoutYear }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="approval-step">
              <div class="approval-progress">
                <div class="progress-dot"></div>
                <div class="progress-line"></div>
              </div>
              <div class="approval-box">
                <div class="approval-item">
                  <div class="approval-role">
                    <span class="text-black-15">{{$t('知会人')}}</span>
                    <span class="text-green-15">{{$t('已知会')}}</span>
                  </div>
                  <div class="approval-users">
                    <div class="user-item" v-for="(operateItem,operateIndex) in detailData.ccList" :key="operateIndex">
                      <div class="user-info">
                        <img class="user-avatar" src="@/assets/avatar-blue.png" alt="">
                        <span class="text-gray-14">{{operateItem.name}}</span>
                      </div>
                      <div class="operate-time text-gray-14">{{queryParams.createTime | formatDateWithoutYear}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- 多级审批功能 -->
            <div v-if="queryParams.flowMode !== 1">
              <div class="approval-step" :class="getWordClass(index)"
                v-for="(arr, index) in (detailData.approverAdvancedList || [])" :key="index">
                <div class="approval-progress">
                  <div class="progress-dot"></div>
                  <div class="progress-line"></div>
                </div>
                <div class="approval-box">
                  <div class="approval-item">
                    <div class="approval-role">
                      <span class="text-black-15">{{ $t('审批人') }}</span>
                      <span>
                        <span :class="getApprovalStatusClass(index)">{{ $t(getApprovalStatus(index)) }}</span>
                      </span>
                    </div>

                    <div class="approval-users">
                      <div class="user-item" v-for="(ele, i) in arr" :key="i">
                        <div class="user-info">
                          <img v-if="!getWordClass(index)" class="user-avatar" src="@/assets/avatar-blue.png" alt="">
                          <img v-else class="user-avatar" src="@/assets/avatar.png" alt="">
                          <span class="text-gray-14 card-name" :title="formateName(ele)">{{ formateName(ele) }}</span>
                        </div>
                        <!-- <div class="operate-time text-gray-14">{{$t('发起审批')}}</div> -->
                        <div class="operate-time text-gray-14">{{ formateTime(index, ele) | formatDateWithoutYear }}</div>
                      </div>
                    </div>

                    <el-tooltip v-if="formateWord(index)" popper-class="tooltip-width-box" effect="dark"
                      :content="formateWord(index)" placement="left">
                      <p class="approval-opinion">{{ formateWord(index) }}</p>
                    </el-tooltip>
                    <!-- <div class="approval-status text-black-15">{{$t(+queryParams.state === 1 ? '同意' : '拒绝')}}</div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 旧的单级审批功能 -->
            <div v-else>
              <div class="approval-step" :class="getWordClass(index)"
                v-for="(ele, index) in (detailData.approverList || [])" :key="index">
                <div class="approval-progress">
                  <div class="progress-dot"></div>
                  <div class="progress-line"></div>
                </div>
                <div class="approval-box">
                  <div class="approval-item">
                    <div class="approval-role">
                      <span class="text-black-15">{{ $t('审批人') }}</span>
                      <span>
                        <span :class="getApprovalStatusClass(index)">{{ $t(getApprovalStatus(index)) }}</span>
                      </span>
                    </div>

                    <div class="approval-users">
                      <div class="user-item">
                        <div class="user-info">
                          <img v-if="!getWordClass(index)" class="user-avatar" src="@/assets/avatar-blue.png" alt="">
                          <img v-else class="user-avatar" src="@/assets/avatar.png" alt="">
                          <span class="text-gray-14 card-name" :title="formateName(ele)">{{ formateName(ele) }}</span>
                        </div>
                        <!-- <div class="operate-time text-gray-14">{{$t('发起审批')}}</div> -->
                        <div class="operate-time text-gray-14">{{ formateTime(index) | formatDateWithoutYear }}</div>
                      </div>
                    </div>

                    <el-tooltip v-if="formateWord(index)" popper-class="tooltip-width-box" effect="dark"
                      :content="formateWord(index)" placement="left">
                      <p class="approval-opinion">{{ formateWord(index) }}</p>
                    </el-tooltip>
                    <!-- <div class="approval-status text-black-15">{{$t(+queryParams.state === 1 ? '同意' : '拒绝')}}</div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="approval-step" v-if="isShowBlock">
              <div class="approval-progress">
                <div class="progress-dot"></div>
                <div class="progress-line"></div>
              </div>
              <div class="approval-box">
                <div class="approval-item">
                  <div class="approval-role">
                    <span class="text-black-15">{{$t('知会人')}}</span>
                    <span class="text-green-15">{{$t('已知会')}}</span>
                  </div>
                  <div class="approval-users">
                    <div class="user-item" v-for="(operateItem,operateIndex) in detailData.ccList" :key="operateIndex">
                      <div class="user-info">
                        <img class="user-avatar" src="@/assets/avatar-blue.png" alt="">
                        <span class="text-gray-14">{{operateItem.name}}</span>
                      </div>
                      <div class="operate-time text-gray-14">{{queryParams.approveTime | formatDateWithoutYear}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="approval-step-end">
              <el-button type="success" icon="el-icon-check" circle size="mini"></el-button>
              <span>{{$t('流程结束')}}</span>
            </div> -->
          </div>
        </el-aside>
      </el-container>
    </el-main>
    <el-divider class="margin-0"></el-divider>
    <el-footer>
      <!--    <div class="postscript">
            <i class="el-icon-edit-outline"></i>
            <span class="text-black-15">附言</span>
          </div>-->
    </el-footer>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="$t('请输入审批意见')"
      :visible.sync="dialogVisible" width="650px" :before-close="handleClose">
      <el-form :model="approvalForm" ref="approvalRef">
        <el-form-item prop="comment">
          <el-input :autosize="{ minRows: 3, maxRows: 5 }" maxlength="100" show-word-limit type="textarea"
            v-model="approvalForm.comment" autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('approvalRef')">{{ $t("提交") }}</el-button>
          <el-button @click="handleClose">{{ $t("取消") }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from 'moment'
// import {filesize} from "filesize"
import Ajax, { ajaxRaw } from "@/ajax";
import Config from '@/config'
import { pureJsonClone } from '@/utils'
export default {
  name: "approval_detail",
  data () {
    return {
      Config,
      queryParams: {},
      approvalForm: {
        comment: ''
      },
      dialogVisible: false,
      isCollapsed: false,
      isFullScreen: false,
      isShowOperateBtn: true,
      pkiValue: false,
      // 1 点击的通过按钮 2 点击的拒绝按钮
      clickBtnType: 1,
      // 当前审批所在平台
      currentPlatform: '',
      applicantDesc: '',
      detailData: {},
      forms: [],
      originForms: [],
      tableData: [],
      i18nData: {}
    }
  },
  computed: {
    stateClass () {
      let state = this.queryParams.state ? parseInt(this.queryParams.state) : 0
      let className;
      switch (state) {
        case 0:
          className = "unhandled"
          break;
        case 1:
          className = "passed"
          break;
        case 101:
          className = "passed"
          break;
        case 102:
          className = "passed"
          break;
        case 103:
          className = "passed"
          break;
        case 2:
          className = "rejected"
          break;
        case 201:
          className = "rejected"
          break;
        case 202:
          className = "rejected"
          break;
        case 203:
          className = "rejected"
          break;
        case 3:
          className = "recalled"
          break;
      }
      return className;
    },
    isShowBlock () {
      return [1, 2].includes(+this.queryParams.state)
    }
  },
  filters: {
    formatDate (timestamp) {
      return moment(parseInt(timestamp)).format('YYYY/MM/DD HH:mm:ss')
    },
    formatDateWithoutYear (timestamp) {
      if (!timestamp) return;
      return moment(timestamp).format('MM/DD HH:mm')
    },
    // formatFileSize(size = 0) {
    //   return filesize(size, {standard: "jedec"})
    // }
  },
  watch: {
    '$i18n.locale' (newLocale) {
      this.reorganizeForm(newLocale);
      this.applicantDescWord();
    }
  },
  methods: {
    getDetailData () {
      const reqData = {
        apId: this.queryParams.apId
      }
      return Ajax({
        url: '/api/approve/detail',
        method: 'get',
        params: reqData
      })
    },
    reorganizeForm (lan) {
      let lanObj = this.i18nData[lan];
      let originFormsCopy = pureJsonClone(this.originForms);
      originFormsCopy.forEach(item => {
        item.title = lanObj[item.title] || item.title;
        switch (item.type) {
          case 'kv':
            item.data.forEach(subItem => {
              if (lanObj[subItem.k]) {
                subItem.k = lanObj[subItem.k];
              }
              if (lanObj[subItem.v]) {
                subItem.v = lanObj[subItem.v];
              }
            })
            break;
          case 'list':
            item.heads.forEach(subItem => {
              if (lanObj[subItem.label]) {
                subItem.label = lanObj[subItem.label];
              }
            })
            item.data.forEach(subItem => {
              if (lanObj[subItem.packageType]) {
                subItem.packageType = lanObj[subItem.packageType];
              }
            })
            break;
          case 'file':
            item.data.forEach(subItem => {
              if (lanObj[subItem.category]) {
                subItem.category = lanObj[subItem.category];
              }
            })
            break;
          case 'remark':
            break;
        }
      })
      this.forms = originFormsCopy;
    },
    async getData () {
      try {
        let data = {};
        let i18nData = {};
        // ota、swbrm 平台 使用自己提供的翻译功能
        const platform = this.queryParams.platform;
        if ((platform || '').includes('ota') ||
          (platform || '').includes('swbrm')) {
          [data, i18nData] = await Promise.allSettled([this.getDetailData(), this.getI18nData(platform)]);
        } else {
          data.value = await this.getDetailData();
          if (data.value.i18n) {
            i18nData.value = JSON.stringify(data.value.i18n);
          }
        }
        // const [data, i18nData] = await Promise.allSettled([this.getDetailData(), this.getI18nData()]);
        // 多级审批 已审批流程中 单一流程多人审批中 审批人排在数组最后一个，保证审批人和审批意见在一起
        const advancedList = data.value.advancedList || [];
        let approverAdvancedList = data.value.approverAdvancedList || [];
        if (advancedList.length && approverAdvancedList.length && this.queryParams.flowMode !== 1) {
          // 通过邮箱匹配。 advancedList 中的数据每一个对应 approverAdvancedList 双维数组中的每一个
          advancedList.forEach((obj, ind) => {
            approverAdvancedList = approverAdvancedList.map((arr, ic) => {
              if (ind === ic) {
                const index = arr.findIndex(objC => obj.approver === objC.email);
                const [element] = arr.splice(index, 1);
                arr.push(element);
              }
              return arr;
            });
          });
        }
        this.detailData = data.value;
        let forms = data.value.forms || [];
        this.originForms = pureJsonClone(forms);
        this.forms = forms;
        if (i18nData.status === 'rejected' || !i18nData.value) {
          return;
        };
        this.i18nData = JSON.parse(i18nData.value);
        this.reorganizeForm(this.$i18n.locale);
        this.applicantDescWord();
      } catch (err) {
        this.$message.error(err.message || err || this.$t('发起查询失败'))
        this.loadingData = false
      }
    },
    getOtaBrmI18nApi (platform) {
      const domain = new URL(window.location.href).hostname;
      const mainDomain = domain.split('.').slice(1).join('.');
      if ((platform || '').includes('ota')) {
        return `//ota-portal.${mainDomain}/api/package/workflow/submit/keyValue`;
      }
      if ((platform || '').includes('swbrm')) {
        return `//swbrm-portal.${mainDomain}/api/v1/baseline/approve/keyValue`;
      }
    },
    getI18nData (platform) {
      return Ajax({
        url: this.getOtaBrmI18nApi(platform),
        method: 'post'
      })
    },
    convert2dArray (arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        return Array.from({ length: Math.ceil(arr.length / 2) }, (v, i) => arr.slice(i * 2, i * 2 + 2));
      }
      return [];
    },
    formatState (state) {
      return this.$t(Config.APPROVAL_STATUS[state])
    },
    getFileLogo (fileType) {
      switch (fileType) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          return require('@/assets/file-icons/img.png')
        case 'doc':
        case 'docx':
          return require('@/assets/file-icons/doc.png')
        case 'xls':
        case 'xlsx':
          return require('@/assets/file-icons/xls.png')
        case 'ppt':
        case 'pptx':
          return require('@/assets/file-icons/ppt.png')
        case 'pdf':
          return require('@/assets/file-icons/pdf.png')
        case 'wps':
          return require('@/assets/file-icons/wps.png')
      }
    },
    toggleSidebar () {
      this.isCollapsed = !this.isCollapsed;
    },
    copyBiz () {
      this.$copyText(this.queryParams.bizId)
        .then(() => {
          this.$message.success(this.$t('复制成功'))
        })
        .catch(err => {
          this.$message.error(this.$t('复制失败'))
        })
    },
    handleApproval (state, url, times = 4) {
      if (times === 0) {
        loading && loading.close()
        this.$message.error(this.$t('PKI认证失败，请重试'));
        return;
      }
      const reqData = {
        state,
        id: +this.queryParams.apId,
        comment: this.approvalForm.comment
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      // 绿色不带header
      let obj = {}
      if (!this.pkiValue) {
        obj = {
          'Esc-Pki': true
        }
      }
      ajaxRaw.post(url, reqData, {
        timeout: url.includes('PKI') ? 1000 * 45 : 5000, // 覆盖默认的超时时间
        headers: obj
      })
        .then((res) => {
          const data = res.data || {};
          if (data && (data.data || [0, 200].includes(data.code))) {
            this.handleClose()
            this.isShowOperateBtn = false
            this.$store.commit('setIsRefreshApprovalList', true)
            this.$confirm(this.$t("操作成功"), this.$t('提示'), {
              confirmButtonText: this.$t('确定'),
              type: 'info',
              showCancelButton: false
            })
              .then(() => {
                this.routerChange()
              });
            return
          }
          this.$message.error(data.msg || data.message || this.$t('操作失败'));
        })
        .catch(err => {
          if (err.response == null) {
            // 浏览器试探请求失败, 待证书完备后重试
            setTimeout(() => {
              console.log("---auto retry");
              this.handleApproval(state, url, times - 1)
            }, 600);
            return;
          }
          const status = err.response.status;
          const data = err.response.data || {};
          // 有可能是电脑上没有 PKI证书 ESC-PKI:true
          if (status === 400 && data && String(data).includes('No required SSL certificate was sent')) {
            this.$message.error(this.$t('PKI认证失败，请重试'));
            return;
          }
          this.$message.error(data.msg || data.message || this.$t('操作失败'));
        })
        .finally(() => {
          this.approvalForm.comment = '';
          loading && loading.close();
        });
    },
    handlePrint () {
      if (!this.isFullScreen) {
        this.isFullScreen = true;
        this.$nextTick(() => {
          window.print();
          this.isFullScreen = false;
        })
      } else {
        window.print();
      }
    },
    handleClose () {
      this.$refs['approvalRef'] && this.$refs['approvalRef'].resetFields();
      this.dialogVisible = false;
    },
    passApproval (num) {
      // 同意审批 并且 平台是security 同时 当前审批最后一级开始审批 增加一个弹窗
      const actList = this.detailData['actionList'] || [];
      if (num === 1 && this.queryParams.platform.includes('security')
        && actList.length === (this.detailData.approverAdvancedList.length - 1)
        && this.queryParams.title === 'UDS 27服务研发密钥') {
        this.securityPrompt(num);
        return;
      }
      // 通过时加一个二次确认 不需要填意见
      if (num === 1) {
        this.$confirm(this.$t('确定通过此审批'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消')
        }).then(() => {
          // OTA单人单节点审批 不需要输入内容
          if (this.queryParams.flowMode === 1) {
            // OTA用这个接口地址 不需要 pki逻辑
            this.handleApproval(num, '/api/approve/update');
            return;
          }
          // 除了 ota 以外的的审批
          this.clickBtnType = num;
          const url = this.getUrl();
          this.handleApproval(this.clickBtnType, url);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('已取消通过')
          });
        });
        return;
      }
      // OTA单人单节点审批 不需要输入内容
      if (this.queryParams.flowMode === 1) {
        // OTA用这个接口地址 不需要 pki逻辑
        this.handleApproval(num, '/api/approve/update');
        return;
      }
      this.clickBtnType = num;
      this.dialogVisible = true;
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.getUrl();
          // 这个接口只有在 有PKI证书的电脑上调用才是正常的 否则会报错 报错信息需要提示一下
          this.handleApproval(this.clickBtnType, url);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getUrl () {
      let url = '/api/approve/update';
      if (this.pkiValue) {
        if (location.host.includes(".dev.") || location.host.includes(".sit.")) {
          url = 'https://' + location.host + ':442/api/approve/cert/updateByPKI';
        }
        // cm环境专属PKI域名
        else if (location.host.includes(".uat.cn-vw.") || location.host.includes(".cn-vw.")) {
          url = 'https://' + location.host.replace('approval-portal', 'approval-portal-pki') + '/api/approve/cert/updateByPKI';
        }
        else {
          url = 'https://' + location.host.replace('cn-vwa.volkswagen-cea.com', 'cea.cariad-technology.cn') + '/api/approve/cert/updateByPKI';
        }
      }
      return url;
    },
    routerChange () {
      this.$router.push('/approval/approval_list');
    },
    securityPrompt (num) {
      // 支持Security进行三级审批的秘钥创建验证提示
      this.$confirm(this.$t('请在审批操作前创建好密钥'), this.$t('提示'), {
        confirmButtonText: this.$t('确定已创建'),
        cancelButtonText: this.$t('取消'),
      }).then(() => {
        this.clickBtnType = num;
        const url = this.getUrl();
        this.handleApproval(this.clickBtnType, url);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('已取消通过')
        });
      });
    },
    getApprovalStatusClass (index) {
      // 只有一层审批单独判断
      if (this.queryParams.flowMode === 1) {
        if (this.queryParams.state === 1) {
          return 'text-green-15';
        }
        if (this.queryParams.state === 2) {
          return 'text-red-15';
        }
      }
      const actionList = this.detailData['actionList'];
      if (actionList && actionList[index] === 1) {
        return 'text-green-15';
      }
      if (actionList && actionList[index] === 2) {
        return 'text-red-15';
      }
      return 'text-black-15';
    },
    getWordClass (index) {
      // 原有单极逻辑单独判断
      if (this.queryParams.flowMode === 1) {
        return '';
      }
      // 只有在未审批状态下 才有当前步骤的判断
      const approvalStatusVal = this.queryParams.approvalStatusVal;
      const actList = this.detailData['actionList'] || [];
      if (actList) {
        // 当前步骤
        if (index == actList.length && approvalStatusVal === '1') {
          return 'current-step';
        }
        // 未来步骤
        else if (!actList[index]) {
          return 'un-active-step'
        }
        // 已过步骤
        else {
          return '';
        }
      }
    },
    getApprovalStatus (index) {
      // 原有单极逻辑单独判断
      if (this.queryParams.flowMode === 1) {
        return Config.APPROVAL_STATUS[this.queryParams.state];
      }
      // 多级审批
      const actionList = this.detailData['actionList'];
      if (actionList && actionList[index] && actionList[index] === 1) {
        return '已通过';
      }
      if (actionList && actionList[index] && actionList[index] === 2) {
        return '拒绝';
      }
      return '未处理';
    },
    formateTime (index, ele) {
      const advancedList = this.detailData['advancedList'];
      if (this.detailData && Array.isArray(advancedList) &&
        advancedList[index] && advancedList[index]['approver'] === ele['email']) {
        return advancedList[index]['approveTime'];
      }
      return '';
    },
    formateWord (index) {
      if (this.detailData && Array.isArray(this.detailData['commentList'])) {
        return this.detailData['commentList'][index];
      }
      return '';
    },
    formateName (ele) {
      // 如果没有name  用 email
      const approverList = this.detailData['approverList'];
      if (ele['name']) {
        return ele['name'];
      }
      if (ele['email']) {
        return ele['email'].split('@')[0];
      }
      return '';
    },
    setBtnShowHide () {
      // 已审批页面 的数据 按钮隐藏
      const approvalStatusVal = this.queryParams.approvalStatusVal;
      const state = this.queryParams.state;
      if (approvalStatusVal === '2' || approvalStatusVal === '3') {
        this.isShowOperateBtn = false;
        return;
      }
      // 未处理 显示
      if (state === 0) {
        this.isShowOperateBtn = true;
        return;
      }
      // 首位是2代表拒绝 按钮不显示
      if (String(state).slice(0, 1) === '2') {
        this.isShowOperateBtn = false;
        return;
      }
      // 同级表示这个流程结束了
      // state        flowMode
      // 101/201      1101
      // 102/202      1102
      // 103/203      1103
      if (state % 10 === this.queryParams.flowMode % 10) {
        this.isShowOperateBtn = false;
        return;
      }
      // 剩下情况都显示
      this.isShowOperateBtn = true;
    },
    applicantDescWord () {
      const lang = this.$i18n.locale;
      const langContent = this.i18nData;
      if (langContent && langContent[lang]) {
        this.applicantDesc = langContent[lang][this.queryParams.applicantDesc];
        return;
      }
      this.applicantDesc = '';
    }
  },
  created () {
    this.queryParams = JSON.parse(decodeURIComponent(atob(this.$route.query.info)));
    this.pkiValue = this.queryParams.usePki && location.host.includes(".cn-vw.");
    this.setBtnShowHide();
  },
  mounted () {
    this.getData()
  }
}
</script>

<style scoped lang="scss">
.full-screen {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background: #fff !important;
}

.main-container {
  padding: 0 25px 0 0;
  position: relative;

  .main-container-scroll {
    height: 100%;
    overflow: auto;
    padding-right: 30px;

    .approval-detail-header {
      .el-icon-document-copy {
        margin-left: 8px;
        cursor: pointer;
      }
    }

    .common-info {
      .info-title {
        display: flex;
        justify-content: space-between;

        .title-left {
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            line-height: 20px;
            margin-left: 8px;
            color: #27AE60;
            font-size: 14px;

            &.passed {
              color: #67C23A;
            }

            &.rejected {
              color: #F56C6C;
            }

            &.recalled {
              color: #409EFF;
            }

            &.unhandled {
              color: #606266;
            }
          }
        }
      }

      .approval-info {
        margin-top: 10px;
      }

      .apply-info {
        margin: 10px 0 5px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .user-info {
          display: flex;
          align-items: center;

          img.user-avatar {
            display: block;
            border-radius: 50%;
            width: 30px;
            height: 30px;
          }

          span.user-name {
            margin: 0 10px;
          }
        }
      }
    }

    .special-info {
      padding-top: 20px;

      .special-item {
        margin-bottom: 20px;

        .special-title {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          .title-icon {
            width: 5px;
            height: 18px;
            background: #409eff;
            margin-right: 8px;
            border-radius: 1px;
          }
        }

        .special-content {
          .type-key-value {
            ::v-deep &>.el-row {
              margin-bottom: 10px;
            }
          }

          .type-list {
            ::v-deep .header-row-class>th {
              background-color: #F5F5F5;
            }
          }

          .type-attachment {
            .attachment-item {
              margin-bottom: 20px;

              .attachment-box {
                height: 50px;
                background: #F0F0F0;
                display: inline-flex;
                align-items: center;
                padding: 15px 20px;
                border-radius: 3px;

                .attachment-log>img {
                  width: 28px;
                }

                .attachment-description {
                  min-width: 250px;
                  margin: 0 10px;

                  .attachment-size {
                    font-size: 13px;
                  }
                }
              }

              .attachment-operation {
                &>i {
                  cursor: pointer;
                }

                .el-icon-view {
                  margin-right: 8px;
                }
              }
            }
          }
        }

        .long-word {
          word-break: break-word;
          white-space: normal;
        }
      }
    }

    /* 整个滚动条 */
    ::-webkit-scrollbar {
      width: 12px;
      /* 滚动条的宽度 */
      height: 12px;
      /* 滚动条的高度 */
    }
  }

  .collapse-bar {
    position: absolute;
    width: 20px;
    right: 0;
    top: 0;
    height: 100%;

    .collapse-line {
      width: 1px;
      height: 100%;
      margin: 0 auto;
      background: #CCCCCC;
    }

    .collapse-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 35px;
      border: 1px solid #CCCCCC;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      background: #fafafa;
      cursor: pointer;

      i {
        color: #CCCCCC;
        font-size: 12px;
      }
    }
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  overflow: auto;

  //width: 235px!important;
  &.collapsed {
    width: 0 !important;
  }


  .approval-step {
    flex: 1;
    display: flex;

    &.current-step {

      .text-gray-14,
      .text-black-15 {
        font-weight: 550;
      }

      .approval-progress {
        .progress-dot {
          font-weight: 550;
        }
      }
    }

    &.un-active-step {

      .text-gray-14,
      .text-black-15 {
        color: #ccc;
      }

      .approval-progress {
        .progress-dot {
          background: #999;
        }
      }
    }


    .approval-progress {
      width: 30px;

      // margin-right: 4px;
      .progress-line {
        margin: 0 auto;
        width: 0;
        height: calc(100% - 10px);
        border-right: 1px dashed #CCCCCC;
      }

      .progress-dot {
        margin: 0 auto;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #409eff;
      }
    }

    .approval-box {
      width: 270px;
      // flex: 1;
      height: 100%;
      padding-bottom: 10px;

      .approval-item {
        width: 100%;
        height: 100%;
        background: #F0F0F0;
        border-radius: 5px;
        padding: 15px 10px;

        .approval-role {
          display: flex;
          justify-content: space-between;
        }

        .approval-users {

          //padding-top: 8px;
          .user-item {
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .user-info {
              display: flex;
              align-items: center;

              .user-avatar {
                display: block;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                margin-right: 10px;
              }

              .card-name {
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: normal;
              }
            }
          }
        }

        .approval-status {
          margin-top: 6px;
          padding: 10px;
          background: #E5E5E5;
          border-radius: 5px;
        }
      }

      .approval-opinion {
        width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: normal;
        height: 30px;
        line-height: 35px;
        border-top: 1px dashed #ccc;
        font-size: 12px;
        margin-top: 15px;
        cursor: pointer;
      }
    }
  }

  .approval-step-end {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    span {
      margin-left: 20px;
    }
  }
}

.postscript {
  float: right;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  cursor: pointer;
}

.padding-0 {
  padding: 0 !important;
}

.margin-0 {
  margin: 0;
}

.height-100 {
  height: 100%;
}

.text-gray-14 {
  color: #666666;
  font-size: 14px;
}

.text-gray-15 {
  color: #666666;
  font-size: 15px;
}

.text-black-15 {
  color: #333333;
  font-size: 15px;
}

.text-green-15 {
  font-weight: 700;
  color: #67C23A;
  font-size: 14px;
}

.text-red-15 {
  font-weight: 700;
  color: #F56C6C;
  font-size: 14px;
}

.un-active-step {
  color: #ccc;
  font-size: 14px;
}

.blood {
  font-weight: bold;
}

/* 整体滚动条样式 */
::-webkit-scrollbar {
  width: 10px;
  /* 滚动条宽度 */
  height: 10px;
  /* 滚动条高度 */
}

/* Webkit 浏览器的滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #999999;
}

/* Firefox 的滚动条 */
html {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
</style>
<style>
.tooltip-width-box {
  width: 200px;
}
</style>
